module.exports = __webpack_public_path__ + "static/media/papua-new-guinea.9c544b34.png";